import React, { Fragment, useContext } from "react";
import DataTable from "react-data-table-component";
import { packagesColumns } from "../../Data/Configuration/Packages";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../Common/Component/ActionOptions";
import { Spinner } from "../../AbstractElements";
import CommonToolTip from "../Common/Component/CommonToolTip";
import CustomizerContext from "../../_helper/Customizer";
import { Link } from "react-router-dom";

const PackagesTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    onEditClick,
    loader
}) => {
    const {mix_background_layout} = useContext(CustomizerContext)
    const processData = tableData.map((element, index) => {
        return {
            name: element.name ? <>
            <Link
            to={`${process.env.PUBLIC_URL}/user/pack/info/${element.id}`}
            >
                <span
                    id={"name" + index}
                    style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                    }}
                >
                    {element.name}
                </span>
                </Link>
                <CommonToolTip
                    options={{
                        placement: "bottom",
                        target: "name" + index,
                    }}
                >
                    {element.name}
                </CommonToolTip>
            </> : "-",
            description: element.description ? element.description : "-",
            isActive: element.isActive ? "true" : "false",
            autoRollover: element.autoRollover ? "true" : "false",
            isAirportExpress: element.isAirportExpress ? "true" : "false",
            serviceCityName: element.serviceCityName ? element.serviceCityName : "-",
            baseFareTaxPercentage: element.baseFareTaxPercentage ? element.baseFareTaxPercentage : "-",
            serviceFareTaxPercentage: element.serviceFareTaxPercentage ? element.serviceFareTaxPercentage : "-",
            // baseFareTaxPercentage: element.baseFareTaxName ? element.baseFareTaxName : "-",
            // serviceFareTaxPercentage: element.serviceTaxName ? element.serviceTaxName : "-",
            isAirportBooking: element.isAirportExpress ? "true" : "false",
            action: (
                <ActionOptions key={index}>
                    <Fragment>
                        <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => onEditClick(element)}
                        >
                            <i className="fa fa-pencil"></i> Edit
                        </DropdownItem>
                    </Fragment>
                </ActionOptions>
            ),
        };
    });
    return (
        <div>
            <div className="table-responsive package-table">
                <DataTable
                    columns={packagesColumns}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
        </div>
    );
};

export default PackagesTable;
